import type { OrderDetailStatus } from '@api/enterprise/openapi/models';

type EnvironmentalData = {
  temperature: string;
  humidity: string;
  pressure: string;
  temperatureUnit: '°F' | '°C';
};

type StatusItem = {
  label: string;
  value: string;
  chipVariant: 'status' | 'metadata';
  chipSize?: 'medium' | 'small';
};

export const buildStatusItems = (
  status: OrderDetailStatus,
  equipmentStatus: string | undefined,
  workStatusLabel: string,
  equipmentStatusLabel: string,
  eventStatusLabel?: string,
  eventNumber?: number | null,
  chipSize?: 'medium' | 'small'
): StatusItem[] => {
  const items: StatusItem[] = [
    {
      label: workStatusLabel,
      value: status,
      chipVariant: 'status',
      chipSize
    }
  ];

  if (equipmentStatus) {
    items.push({
      label: equipmentStatusLabel,
      value: equipmentStatus,
      chipVariant: 'metadata',
      chipSize
    });
  }

  if (eventStatusLabel) {
    items.push({
      label: eventStatusLabel,
      value: eventNumber ? 'Complete' : 'Incomplete',
      chipVariant: 'status',
      chipSize
    });
  }

  return items;
};

type CalibrationDataPart = {
  value: string | number;
  unit?: string;
};

export const formatCalibrationData = (
  environmentalData: EnvironmentalData | undefined
): string => {
  if (!environmentalData) {
    return '';
  }

  const parts: CalibrationDataPart[] = [
    {
      value: environmentalData.temperature || '--',
      unit: `°${environmentalData.temperatureUnit === '°C' ? 'C' : 'F'}`
    },
    { value: environmentalData.humidity || '--', unit: '%' },
    { value: environmentalData.pressure || '--', unit: ' inHg' }
  ];

  return parts.map(({ value, unit }) => `${value}${unit || ''}`).join(' · ');
};
